module.exports = __webpack_public_path__ + "static/media/page02-bg.a12a0494.svg";